import styled from '@emotion/styled';
import { media, mediaQueries } from '../../../style/global-style';

interface IListProps {
    color: string;
}

export const StyledListItem = styled.li`
    display: flex;
    align-items: baseline;

    ${media.tablet`
        width: 33%;
        padding: 5px 0;
    `}

    span {
        margin-left: 10px;
        font-size: ${(props) => props.theme.fontSize.copyTextM};
        font-weight: 700;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.69;
        letter-spacing: normal;
        word-break: break-word;

        @media ${mediaQueries.tablet} {
            font-size: ${(props) => props.theme.fontSize.copyTextL};
            line-height: 1.47;
        }
    }
`;

export const StyledWrapper = styled.ul<IListProps>`
    display: flex;
    flex-direction: column;
    list-style: none;
    padding-left: 0;
    margin-bottom: 0;
    color: ${(props) => props.color};

    ${media.tablet`
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
    `};
`;

export const StyledIconWrapper = styled.div`
    height: 22px;
    width: 22px;
    transform: translateY(2px);

    ${media.tablet`
        height: 25px;
        width: 25px;
    `};
`;
